import type { AppCategory } from "../types/appIntegration.types";

export const APP_CATEGORIES: Record<
  AppCategory,
  {
    name: string;
    description: string;
    color: string;
  }
> = {
  payments: {
    name: "Payments",
    description: "Accept and manage customer payments",
    color: "#2196F3",
  },
  ecommerce: {
    name: "E-commerce",
    description: "Sell products and manage online stores",
    color: "#4CAF50",
  },
  marketing: {
    name: "Marketing",
    description: "Grow and engage your audience",
    color: "#FF9800",
  },
  analytics: {
    name: "Analytics",
    description: "Track performance and insights",
    color: "#673AB7",
  },
  communication: {
    name: "Communication",
    description: "Chat, email, and customer messaging",
    color: "#E91E63",
  },
  integrations: {
    name: "Integrations",
    description: "Connect with external tools",
    color: "#00BCD4",
  },
};
